export enum SessionChartingDataSpan {
    Hour,
    Day,
    Week,
    Month
}
